import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import InvestmentCard, {
  InvestmentCardSkeleton,
} from '../../components/CrowdCards/InvestmentCard';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight, Music2 } from 'lucide-react';
import './Marketplace.css';
import '../../styles/DarkMarketplace.scss';
import {
  campaignStatus,
  campaignMetrics,
} from '../../components/CrowdCards/campaignPresentation';

import AppServices from '../../services/AppService';
import { CarouselHome } from './Carousel';
import FeaturedMusic from './FeaturedMusic';
import '../../styles/KycLayout.scss';

const InvestCrowdsale = lazy(() => import('../../components/Invest/Invest'));

const CrowdsaleDetails = lazy(() =>
  import('../../components/CrowdsaleDetails/CrowdsaleDetails')
);

const AnchorInvestModal = lazy(() =>
  import('../AnchorWallet/AnchorInvestModal')
);

const appServices = new AppServices();

const HomePage = ({ ual }) => {
  const [show, setShow] = useState(false);
  const [showcrowdsale, setShowCrowdsale] = useState(false);
  const [crowdsaledata, setCrowdsaleData] = useState(false);
  const history = useHistory();
  const userDetails = useSelector((state) => state.user.data);
  const [text, setText] = useState('Crowdsale');
  const {
    popularcrowdsaleError,
    recommendcrowdsaleError,
    livecrowdfundError,
    popularcrowdsaleloading,
    livecrowdfundloading,
    recommendcrowdsaleloading,
    popularcrowdsale,
    livecrowdfund,
    livecrowdsale,
    liveprice,
    successfulcrowdsale,
    finalizedcrowdsale,
    finalizedcrowdfund,
    recommendcrowdsale,
    recentcrowdsale,
  } = useSelector((state) => state.crowdsale);
  const userdata = useSelector((state) => state.user.data);
  const bookmarks = useSelector((state) => state.user.bookmarks);

  const handleInvest = (el, type) => {
    setCrowdsaleData(el);
    setText(type === 'crowdfund' ? 'Crowdfund' : 'Crowdsale');
    setShow(true);
  };

  useEffect(() => {
    if (
      userDetails &&
      userDetails?.walletCreated &&
      userDetails?.wallet_pin_changed === false
    ) {
      history.push('/profile');
    }
  }, [userDetails, history]);

  const handleCrowdsaleDetails = (el) => {
    setCrowdsaleData(el);
    setShowCrowdsale(true);
  };

  const [exploreFilter, setExploreFilter] = useState('All');
  const used = new Set();
  const pick = (collection, limit = 4, type) => {
    const result = [];
    for (const el of collection?.data || []) {
      if (!el?._id || used.has(String(el._id))) continue;
      used.add(String(el._id));
      result.push({ el, type });
      if (result.length === limit) break;
    }
    return result;
  };
  const popular = pick(popularcrowdsale);
  const crowdfunding = pick(
    {
      data: (livecrowdfund?.data || []).filter(
        (el) =>
          campaignStatus(el, campaignMetrics(el, liveprice).soldOut).canInvest
      ),
    },
    4,
    'crowdfund'
  );
  const recommended = pick(recommendcrowdsale);
  const remaining = [
    ...pick(livecrowdsale, 8, 'crowdsale'),
    ...pick(livecrowdfund, 8, 'crowdfund'),
    ...pick(recentcrowdsale, 8),
    ...pick(finalizedcrowdsale, 8, 'crowdsale'),
    ...pick(finalizedcrowdfund, 8, 'crowdfund'),
    ...pick(successfulcrowdsale, 8),
  ];
  const explore = remaining
    .filter(
      ({ el }) =>
        exploreFilter === 'All' ||
        (exploreFilter === 'Live' &&
          campaignStatus(el, campaignMetrics(el, liveprice).soldOut)
            .canInvest) ||
        (exploreFilter === 'Upcoming' && el.state === 'finalised') ||
        (exploreFilter === 'Funded' && el.state === 'successful')
    )
    .slice(0, 8);
  const catalogue = [
    popularcrowdsale,
    recommendcrowdsale,
    recentcrowdsale,
    livecrowdsale,
    livecrowdfund,
  ].flatMap((collection) => collection?.data || []);
  const renderCards = (items) =>
    items.map(({ el, type }) => (
      <InvestmentCard
        key={el._id}
        el={el}
        type={type}
        liveprice={liveprice}
        handleCrowdsaleDetails={handleCrowdsaleDetails}
        handleInvest={handleInvest}
        userid={userdata?._id}
        isBookmark={(bookmarks || []).some(
          (item) => item.crowdsaleId === el._id
        )}
      />
    ));
  const section = (
    title,
    description,
    items,
    path,
    loading,
    empty,
    error = false,
    surface = ''
  ) =>
    !items.length && !loading && !error ? null : (
      <section className={`tm-market-section ${surface}`} aria-label={title}>
        <div className="tm-section-heading">
          <div>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
          <Link to={path}>
            View all <ArrowUpRight size={16} aria-hidden="true" />
          </Link>
        </div>
        {error && !items.length ? (
          <div className="tm-market-empty" role="alert">
            <p>We couldn’t load these offerings. Please try again.</p>
            <button
              className="tm-reload-offerings"
              onClick={() => history.go(0)}
            >
              Reload offerings
            </button>
          </div>
        ) : loading && !items.length ? (
          <div
            className="tm-market-grid"
            role="status"
            aria-label="Loading offerings"
          >
            {[0, 1, 2, 3].map((key) => (
              <InvestmentCardSkeleton key={key} />
            ))}
          </div>
        ) : items.length ? (
          <div className="tm-market-grid">{renderCards(items)}</div>
        ) : (
          <div className="tm-market-empty">
            <Music2 size={20} aria-hidden="true" />
            <p>{empty}</p>
            <Link to={path}>
              Explore campaigns <ArrowRight size={15} aria-hidden="true" />
            </Link>
          </div>
        )}
      </section>
    );

  return (
    <main className="tm-marketplace tm-dark-marketplace">
      <div className="tm-market-container">
        <section className="tm-discovery" aria-labelledby="tm-discovery-title">
          <div>
            <span className="tm-discovery-kicker">
              THE MUSIC RIGHTS MARKETPLACE
            </span>
            <h1 id="tm-discovery-title">
              Invest in the music
              <br />
              you believe in.
            </h1>
            <p>
              Discover music rights offerings and support the next chapter of
              music. Explore the possibilities. Understand the investment.
            </p>
            <div className="tm-discovery-actions">
              <Link className="tm-discovery-primary" to="/home/campaigns">
                Explore Music <ArrowRight size={16} aria-hidden="true" />
              </Link>
              <Link to="/faq">
                How It Works <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
            </div>
          </div>
          <FeaturedMusic
            campaigns={catalogue}
            onDetails={handleCrowdsaleDetails}
            liveprice={liveprice}
            hero
          />
        </section>
        <CarouselHome />
        <Suspense
          fallback={
            <div className="tm-modal-loading" role="status">
              Loading details…
            </div>
          }
        >
          {show && !(appServices.isLogin() || ual?.activeUser) && (
            <InvestCrowdsale
              show={show}
              setShow={setShow}
              text={text}
              liveprice={liveprice}
              crowdsaledata={crowdsaledata}
            />
          )}
          {show && (appServices.isLogin() || ual?.activeUser) && (
            <AnchorInvestModal
              show={show}
              setShow={setShow}
              text={text}
              liveprice={liveprice}
              crowdsaledata={crowdsaledata}
              ual={ual}
            />
          )}
          {showcrowdsale && (
            <CrowdsaleDetails
              show={showcrowdsale}
              setShow={setShowCrowdsale}
              data={crowdsaledata}
              liveprice={liveprice}
              onInvest={handleInvest}
              userid={userdata?._id}
            />
          )}
        </Suspense>
        {section(
          'Popular music offerings',
          'Explore the offerings attracting interest on TokenizeMe.',
          popular,
          '/home/popularcrowdsale',
          popularcrowdsaleloading,
          'No popular offerings are available right now.',
          popularcrowdsaleError,
          'tm-section-popular'
        )}
        <FeaturedMusic
          campaigns={[...(recentcrowdsale?.data || []), ...catalogue]}
          onDetails={handleCrowdsaleDetails}
          liveprice={liveprice}
        />
        {section(
          'Live crowdfunding campaigns',
          'Support the creation of new music through live campaigns.',
          crowdfunding,
          '/home/crowdfund',
          livecrowdfundloading,
          'No additional live crowdfunding campaigns. Browse all campaigns for availability.',
          livecrowdfundError,
          'tm-section-crowdfunding'
        )}
        {section(
          'Recommended music',
          'Selected offerings from the platform’s recommendation list.',
          recommended,
          '/home/campaigns',
          recommendcrowdsaleloading,
          recommendcrowdsale?.data?.length
            ? 'The current recommendations are already featured above. Explore more music below.'
            : 'No additional recommendations are available right now.',
          recommendcrowdsaleError,
          'tm-section-recommended'
        )}
        {remaining.length > 0 && (
          <section
            className="tm-market-section"
            aria-label="Explore more music"
          >
            <div className="tm-section-heading">
              <div>
                <h2>Explore more music</h2>
                <p>
                  Browse more offerings, upcoming campaigns, and funded music.
                </p>
              </div>
              <Link to="/home/campaigns">
                View all <ArrowUpRight size={16} aria-hidden="true" />
              </Link>
            </div>
            <div className="tm-explore-toolbar">
              <div role="group" aria-label="Filter music by status">
                {['All', 'Live', 'Upcoming', 'Funded'].map((filter) => (
                  <button
                    key={filter}
                    aria-pressed={exploreFilter === filter}
                    onClick={() => setExploreFilter(filter)}
                  >
                    {filter}
                  </button>
                ))}
              </div>
              <Link to="/trade">
                Open trading marketplace{' '}
                <ArrowUpRight size={15} aria-hidden="true" />
              </Link>
            </div>
            {explore.length ? (
              <div className="tm-market-grid">{renderCards(explore)}</div>
            ) : (
              <div className="tm-market-empty">
                <Music2 size={20} aria-hidden="true" />
                <p>
                  No additional{' '}
                  {exploreFilter === 'All'
                    ? ''
                    : exploreFilter.toLowerCase() + ' '}
                  offerings in this preview.
                </p>
                <Link
                  to={
                    exploreFilter === 'Upcoming'
                      ? '/home/upcoming'
                      : exploreFilter === 'Funded'
                      ? '/home/successfulcrowdsale'
                      : '/home/campaigns'
                  }
                >
                  Browse all offerings{' '}
                  <ArrowRight size={15} aria-hidden="true" />
                </Link>
              </div>
            )}
            <nav
              className="tm-campaign-directory"
              aria-label="Campaign collections"
            >
              <Link to="/home/crowdsale">Live music rights</Link>
              <Link to="/home/upcoming">Upcoming offerings</Link>
              <Link to="/home/upcomingcrowdfund">Upcoming crowdfunding</Link>
              <Link to="/home/successfulcrowdsale">Funded campaigns</Link>
            </nav>
          </section>
        )}
        <p className="tm-market-risk">
          Music investment involves risk. Funding progress is informational; USD
          equivalents may change with the XLM exchange rate. Review each
          offering’s terms before investing.
        </p>
      </div>
    </main>
  );
};
export default HomePage;
